import { SafeBaseObject } from '@app/core/models/base-object.models';
import { ReservationPackageEcmData } from '@app/reservation/models/res-package-detail.model';
import { ResProductCalendarVoyages } from '@app/reservation/models/res-product.models';
import { DateTime } from 'luxon';

export interface IResExpAvailabilityGetParams {
  ExperienceID:number
  ExperienceTemplateHdrID:number | undefined
  PriceTypeID:number
	Currency:string
	ItineraryDate:DateTime | undefined

  BkgID?:number
}
export interface ResExperiencesApiParams {
  ExperienceID:number
  ExperienceTemplateHdrID:number
  GuestCod:string
  ItineraryDate:DateTime
}
export interface ResBkgExperiencesApiParams {
  BkgID:number
  BookExperience:ResExperiencesApiParams[]
}

export interface ResBkgExperienceManageChoicesApiParams {
  BkgID:number
  Optional: {
    ItemListID: number
    ServiceID: number
    OptionID: number
  }[]
}

export class ResExpAvailability extends SafeBaseObject {

  internalType = 'experience';
  experienceID = 0
  experienceName = ''
  experienceType = ''
  description = ''
  city = 0

  minPax = 1
  maxPax = 20

  duration = 240

  templates:ResExperienceTemplate[] = []

  constructor(data?: any) {
    super()
    this.updateData(data)
  }

  override updateData(data: any): void {
    if (!data) return
    super.updateData(data)

    if(data.templates) {
      this.templates = data.templates.map((t:any)=>new ResExperienceTemplate(t))
      if(this.templates.length===1) this.templates[0].selected=true
    }
  }

  get isValid(): boolean {
    return this.experienceID !== ResExperience.INVALID_EXPERIENCE_ID
  }
}

export class ResExperienceTemplate extends SafeBaseObject {
  experienceID	= 0
  experienceTemplateHdrID	= 0
  templateName = ''
  description = ''
  minPax = 1
  maxPax = 20
  cost = 0
  costCurrency = ''
  price = 0
  priceCurrency = ''

  selected = false

  items:ResExperienceItem[] = []

  constructor(data?: any) {
    super()
    this.updateData(data)
  }

  override updateData(data: any): void {
    if (!data) return
    super.updateData(data)
    if(data.items) this.items = data.items.map((i:any)=>new ResExperienceItem(i))
  }

}
export class ResExperienceItem extends SafeBaseObject {
  experienceID	= 0
  experienceTemplateHdrID = 0
  sequence = 0
  description = ''
  serviceTypeName = ''
  serviceName = ''
  optionName = ''
  duration = 0
  notes = ''
  internalNotes = ''

  constructor(data?: any) {
    super()
    this.updateData(data)
  }

  override updateData(data: any): void {
    if (!data) return
    super.updateData(data)
  }

}
export class ResExperience extends SafeBaseObject {
  static INVALID_EXPERIENCE_ID = 0
  experienceID = 0
  internalType = 'experience';
  description = ''
  city = ''
  ecmData = new ReservationPackageEcmData();
  calendarVoyages = new ResProductCalendarVoyages()
  voyageID = 0
  duration = 0
  productCod = ''
  itineraryDate = DateTime.invalid('EMPTY')


  experienceCode = ''
  experienceName = ''
  experienceTypeID = 0
  cityID = 0
  minPax = 0
  maxPax = 0
  shortDescription = ''
  notes = ''
  internalNotes = ''
  startDate = DateTime.invalid('EMPTY')
  endDate = DateTime.invalid('EMPTY')

  templates:ResExperienceTemplate[] = []

  constructor(data?: any) {
    super()
    this.updateData(data)
  }

  override updateData(data: any): void {
    if (!data) return
    super.updateData(data)
    if(data.templates) this.templates = data.templates.map((t:any)=>new ResExperienceTemplate(t))

  }

  get isValid(): boolean {
    return this.experienceID !== ResExperience.INVALID_EXPERIENCE_ID
  }

  get productID() {
    return this.experienceID
  }
  get hasMediaData() {
    return this.ecmData.loaded
  }
  get hasImages() {
    return this.ecmData.images.length > 0
  }
  get hasMap() {
    return !!this.ecmData.imageMapSafe
  }
  get imagesUrl() {
    return this.ecmData.imagesSafe
  }
  get mapUrl() {
    return this.ecmData.imageMapSafe
  }
  get isOverNight() {
    return false
  }
  get isAnchor() {
    return false
  }
  get priceTM() {
    return false
  }
  getStartDate() {
    return this.itineraryDate
  }
  getEndDate() {
    return this.itineraryDate
  }
  displayName() {
    return this.description
  }
  reloadPrices() {

  }
}

export class ResExperienceOptional extends SafeBaseObject {
  experienceID = 0
  serviceTypeID = 0
  serviceTypeName = ''
  serviceID = 0
  serviceName = ''
  optionID = 0
  optionName = ''
  key = ''
  isSelected = false

  constructor(data?: any) {
    super()
    this.updateData(data)
  }

  override updateData(data: any): void {
    if (!data) return
    super.updateData(data)
    this.key = `${this.experienceID}-${this.serviceID}-${this.optionID}`
  }
}
